import Tooltip from '@mui/material/Tooltip'
import * as React from 'react'
import { Status } from '@/modules/device-module/types/deviceType'
import errorRed from '@/assets/img/error-red.png'
import error from '@/assets/img/icons-error.png'
import ok from '@/assets/img/ok-green.png'

const ErrorStatusIcon = ({
  state,
  errorMessage,
}: {
  state?: number
  errorMessage: string | null
}) => {
  return (
    <>
      {state && state > 1 ? (
        <Tooltip
          title={errorMessage}
          placement='top'
        >
          <img
            src={
              state === Status.error
                ? errorRed
                : state === Status.warning
                  ? error
                  : ok
            }
            alt='Ошибка'
            width={25}
            height={25}
          />
        </Tooltip>
      ) : null}
    </>
  )
}

export default ErrorStatusIcon
